<template>

  <v-row no-gutters>
    <v-col>
      <v-toolbar dense :elevation="0">
        <v-toolbar-title class="text-primary-700">Notifications</v-toolbar-title>
        <v-btn-toggle class="ml-2"
          v-model="tableType"
          tile
          group
          mandatory
          style="float:right"
        >
          <v-badge class="ml-2" overlap bordered :content="counts.date_alert" :value="counts.date_alert > 0" :style="`margin-right:${badgeMargin(counts.date_alert)}px`">
            <v-btn value="date_alert" :style="counts.date_alert > 9 ? `margin-right:-${badgeMargin(counts.date_alert) - 20}px; padding-right:${badgeMargin(counts.date_alert)}px` : ''">
              Date Alerts
            </v-btn>
          </v-badge>
          <v-badge class="ml-2" overlap bordered :content="counts.tenant_changed" :value="counts.tenant_changed > 0" :style="`margin-right:${badgeMargin(counts.tenant_changed)}px`">
            <v-btn value="tenant_changed" :style="counts.tenant_changed > 9 ? `margin-right:-${badgeMargin(counts.tenant_changed) - 20}px; padding-right:${badgeMargin(counts.tenant_changed)}px` : ''">
              Tenant Changes
            </v-btn>
          </v-badge>
          <v-badge class="ml-2" overlap bordered :content="counts.others" :value="counts.others > 0" :style="`margin-right:${badgeMargin(counts.others)}px`">
            <v-btn value="notification" :style="counts.others > 9 ? `margin-right:-${badgeMargin(counts.others) - 20}px; padding-right:${badgeMargin(counts.others)}px` : ''">
              Others
            </v-btn>
          </v-badge>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-table-search"
          label="Search"
          single-line
          outlined dense
          class=""
          style="max-width: 500px;"
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          style="border: 1px solid #e0e0e0; border-radius: 4px;"
          :headers="headers"
          :items="records"
          :options.sync="pagination"
          :loading="loading"
          :server-items-length="totalRecords"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :page.sync="page"
          :footer-props="{
                          'items-per-page-options': [50, 100, 500],
                        }"

        >
          <template v-slot:body="{ items }">
            <tbody v-if="initLoader">
                <tr v-for="n in 10" :key="n">
                    <td class="px-0 table-loading"  :colspan="headers.length">
                        <v-skeleton-loader
                        type="list-item"
                        ></v-skeleton-loader>
                    </td>
                </tr>
            </tbody>
            <tbody v-else-if="records.length > 0">
              <tr v-for="item in items" :key="item.id">
                <td :class="!item.is_read ? 'font-weight-bold' : ''">{{ item.message }}</td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.actor.data.name ? item.actor.data.name : 'System' }}</td>
                <td >
                  <!-- <v-btn v-if="tableType === 'tenant_changed'" x-small @click="redirectToNewDeal(item)" class="mr-2">
                    New Deal
                  </v-btn> -->
                  <v-icon @click="showEntityInfo(item)" small>
                    mdi-eye
                  </v-icon>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5" class="text-center">There are currently no Notifications</td>
                </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
      <edit-standalone-property-dialog ref="editStandalonePropertyDialog"></edit-standalone-property-dialog>
      <edit-property-dialog ref="editPropertyDialog"></edit-property-dialog>
    </v-col>
  </v-row>

</template>

<script>

import EditPropertyDialog from "@/components/properties/editPropertyDialog.vue";
import EditStandalonePropertyDialog from "@/components/properties/editStandalonePropertyDialog.vue";
import EditSchemeDialog from "@/components/schemes/editSchemeDialog.vue";

export default {
  components: {EditSchemeDialog, EditStandalonePropertyDialog, EditPropertyDialog},
  data() {
    return {
      search: '',
      pagination: {},
      totalRecords: 0,
      loading: true,
      initLoader: true,
      sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 50,
      page: 1,
      tableType: 'date_alert',

      counts: {
        date_alert: 0,
        others: 0,
      },

      headers: [
        {text: 'Message', value: 'name'},
        {text: 'Date', value: 'created_at'},
        {text: 'Actor', value: 'actor'},
        {text: '', value: 'actions', sortable: false},
      ],
      records: [],
      _timerId: null,
    }
  },
  mounted() {
    // this.getData()
    this.getCounts()
  },
  watch: {
    pagination: {
      handler() {
        this.getData()
      },
      deep: true
    },
    search() {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.page = 1
        this.getData()
      }, 500)
    },
    tableType() {
      this.getData()
    },
  },
  filters: {

  },
  methods: {
    redirectToNewDeal(item) {
      this.$router.push({name: 'unknownDealWizard', query: {property_id: item.subscribable_id}})
    },
    showEntityInfo(item) {
      const entity = item.subscribable.data;
      if (item.subscribable_type === 'scheme') {
        this.$refs.editSchemeDialog.showDialog(item.subscribable_id);
      }
      if (item.subscribable_type === 'property') {
        if (entity.scheme_id) {
          this.$refs.editPropertyDialog.showDialog(item.subscribable_id);
        } else {
          this.$refs.editStandalonePropertyDialog.showDialog(item.subscribable_id);
        }
      }
    },
    badgeMargin(count) {
      // return an increase in the margin for the badge based on the digit, the breakpoints increasing at 10, 100, 1000, 10000, 100000 etc
      if (count < 10) return 5;
      if (count < 100) return 20;
      if (count < 1000) return 25;
      if (count < 10000) return 30;
      if (count < 100000) return 35;

    },
    getCounts(){
      this.$http.get('/notifications/counts').then(response => {
        console.log(response)
        this.counts.date_alert = response.data['Date Alerts']
        this.counts.others = response.data['Others']
        this.counts.tenant_changed = response.data['Tenant Changes']
      })
    },
    getData() {
      this.loading = true
      this.$http.get('/notifications', {
        params: {
          q: this.search,
          page: this.pagination.page,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.pagination.itemsPerPage,
          include: 'actor,subscribable',
          type: this.tableType,
        }
      }).then(response => {
        const pagination = response.data.meta.pagination
        this.totalRecords = pagination.total
        this.records = response.data.data
        this.loading = false
        this.initLoader = false
        this.$store.dispatch('getNotificationsCount')
      }).catch(error => {
        console.log(error)
        this.loading = false
        this.initLoader = false
      })
    },
  }
}
</script>

<style scoped>
.table-link {
  text-decoration: none;
}
</style>
